import ReactDOM from 'react-dom';
import React from 'react';
import useWaitForDOMRef from './useWaitForDOMRef';

/**
 * @public
 */
var Portal = function Portal(_ref) {
  var container = _ref.container,
      children = _ref.children,
      onRendered = _ref.onRendered;
  var resolvedContainer = useWaitForDOMRef(container, onRendered);
  return resolvedContainer ? /*#__PURE__*/React.createElement(React.Fragment, null, ReactDOM.createPortal(children, resolvedContainer)) : null;
};

Portal.displayName = 'Portal';
export default Portal;